<template>
    <aside class="db-sidebar">
        <div class="db-sidebar-header">
            <router-link class="w-52" :to="{ name: 'frontend.home' }" @click="closeSidebar">
                <img :src="setting.theme_logo" alt="logo">
            </router-link>
            <button @click="closeSidebar" class="fa-solid fa-xmark xmark-btn close-db-menu"></button>
        </div>
        <button @click="closeSidebar" class="absolute top-2 right-2 fa-solid fa-xmark xmark-btn close-db-menu"></button>
        <nav class="db-sidebar-nav">
            <ul class="db-sidebar-nav-list" v-if="menus.length > 0" v-for="menu in menus" :key="menu">
                <li class="db-sidebar-nav-item" v-if="menu.url === '#'">
                    <a href="javascript:void(0);" class="db-sidebar-nav-title px-3 mt-3">
                        {{ $t('menu.' + menu.language) }}
                    </a>
                </li>

                <li class="db-sidebar-nav-item" :class="{ 'active': isItemActive(menu.url) }" v-else @click="handleItemClick">
                    <router-link :to="'/admin/' + menu.url" class="db-sidebar-nav-menu">
                        <i class="text-sm" :class="menu.icon"></i>
                        <span class="text-base flex-auto">{{ $t('menu.' + menu.language) }}</span>
                    </router-link>
                </li>

                <li class="db-sidebar-nav-item" :class="{ 'active': isItemActive(children.url) }" v-if="menu.children" v-for="children in menu.children" :key="children" @click="handleItemClick">
                    <router-link :to="'/admin/' + children.url" class="db-sidebar-nav-menu">
                        <i class="text-sm" :class="children.icon"></i>
                        <span class="text-base flex-auto">{{ $t('menu.' + children.language) }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </aside>
</template>

<script>
import appService from "../../../services/appService";
export default {
    name: "BackendMenuComponent",
    data: function () {
        return {
            activeParentId: 1,
            activeChildId: 0
        }
    },
    computed: {
        setting: function () {
            return this.$store.getters['frontendSetting/lists'];
        },
        menus: function () {
            return this.$store.getters.authMenu;
        }
    },
    methods: {
        isItemActive: function (url) {
            if (!url || url === '#' || !this.$route) {
                return false;
            }
            const currentPath = (this.$route.path || '').toLowerCase();
            const targetPath = ('/admin/' + url).toLowerCase();

            // Coincidencia exacta
            if (currentPath === targetPath) {
                return true;
            }

            // Coincidencia de subrutas (ej: /admin/productos/crear o /admin/productos/show/1)
            // Asegurando delimitador de slash para no confundir 'pedidos' con 'pedidos-pos'
            if (targetPath !== '/admin' && targetPath !== '/admin/' && currentPath.startsWith(targetPath + '/')) {
                return true;
            }

            return false;
        },
        handleItemClick: function () {
            if (window.innerWidth < 768) {
                appService.closeSidebar();
            }
        },
        closeSidebar: function () {
            return appService.closeSidebar();
        }
    }
}
</script>
